import { FestivalCodesEnum, FestivalStateEnum } from '~/app/generated/graphql'
import { Maybe } from '~/app/generated/strapi'

export const FESTIVAL_CODE_TO_SLUG = {
  gw: 'ginweek',
  rw: 'restaurant-week',
  fdw: 'fine-dining-week',
  bw: 'breakfast-week',
  pw: 'pizzaweek',
}

export const getFestivalSlugFromCode = (code?: Maybe<string>) => {
  switch (code) {
    case FestivalCodesEnum.Rw:
      return FESTIVAL_CODE_TO_SLUG.rw
    case FestivalCodesEnum.Fdw:
      return FESTIVAL_CODE_TO_SLUG.fdw
    case FestivalCodesEnum.Bw:
      return FESTIVAL_CODE_TO_SLUG.bw
    case FestivalCodesEnum.Pw:
      return FESTIVAL_CODE_TO_SLUG.pw
    case FestivalCodesEnum.Gw:
      return FESTIVAL_CODE_TO_SLUG.gw
    default:
      return undefined
  }
}

export const formatPrice = (price: number | string) => {
  const numPrice = typeof price === 'string' ? parseFloat(price) : price
  const envCurrency = 'PLN' // TODO: detect currency

  return numPrice?.toLocaleString('pl-PL', {
    style: 'currency',
    currency: envCurrency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}

interface GetRedirectUrlProps {
  festivalEditionState?: FestivalStateEnum
  festivalEditionId?: string | number
  festivalSlug?: string
  clubUrl?: string
  allowRedirectToFestivalsListing?: boolean
}

export const getRedirectUrl = ({
  festivalEditionState,
  festivalEditionId,
  festivalSlug,
  clubUrl,
  allowRedirectToFestivalsListing,
}: GetRedirectUrlProps): string | undefined => {
  const domain = clubUrl || process.env.NEXT_PUBLIC_CLUB_URL

  switch (festivalEditionState) {
    case FestivalStateEnum.Voucher:
      return `${domain}/voucher-details/${festivalEditionId}`
    case FestivalStateEnum.Presale:
      return `${domain}/early-reservation/${festivalEditionId}`
    case FestivalStateEnum.Sale:
      return `${domain}/restaurants/festival/${festivalSlug || ''}`
    default:
      return allowRedirectToFestivalsListing ? `${domain}/festivals` : undefined
  }
}

export const hasWindow = () => typeof window !== 'undefined'

export const formatPriceWithComma = (price: number) => price.toString().replace('.', ',')
